import React, {
  forwardRef,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';
import { useTheme } from 'styled-components';

import {
  InputStructure,
  InputStructureProps,
} from '../structures/InputStructure';

import { ScInput, ScInputIcon, ScInputInternalLabel } from './styled';
import { Spinner } from '@/styles/common';

export type InputBlockProps = InputHTMLAttributes<HTMLInputElement> &
  InputStructureProps & {
    icon?: string;
    approved?: boolean;
    internalLabel?: string;
    pending?: boolean;
  };

export const InputBlock = forwardRef<HTMLInputElement, InputBlockProps>(
  (
    {
      error,
      hideErrorMessage,
      disabled,
      icon,
      internalLabel,
      autoFocus,
      pending,
      ...rest
    },
    ref
  ) => {
    const { mainColor, gray1Color } = useTheme();

    const [inputRightPadding, setInputRightPadding] = useState(0);

    useEffect(() => {
      if (autoFocus && ref) {
        const timerId = setTimeout(() => {
          if (typeof ref !== 'function' && ref.current) {
            ref.current.focus();
          }
        }, 0);

        return () => clearTimeout(timerId);
      }
    }, [autoFocus, ref]);

    return (
      <InputStructure
        error={error}
        hideErrorMessage={hideErrorMessage}
        disabled={disabled}
        setInputRightPadding={setInputRightPadding}
        {...rest}
      >
        {pending && (
          <Spinner size={20} color={mainColor} background={gray1Color} center />
        )}
        {icon && <ScInputIcon src={icon} alt="" />}
        {internalLabel && (
          <ScInputInternalLabel
            ref={(node: HTMLSpanElement | null) =>
              node && setInputRightPadding(node.clientWidth + 16)
            }
          >
            {internalLabel}
          </ScInputInternalLabel>
        )}
        <ScInput
          {...rest}
          value={pending ? '' : rest.value}
          icon={icon != null}
          error={error != null}
          ref={ref}
          disabled={disabled}
          autoFocus={autoFocus}
          inputRightPadding={inputRightPadding}
        />
      </InputStructure>
    );
  }
);
